import React, {Component} from 'react';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock} from 'react-bootstrap';
import {connect} from 'react-redux';
import validator from 'validator';
import {addQuestion, updateQuestion} from '../../utils/actions/createAssessment';

class EditAssessmentQuestion extends Component {
  constructor(props) {
    super(props);

    let presetQuestion = props.match.params.qId && props.assessment.subsections[props.match.params.subId].questions[props.match.params.qId];
    this.state = {
      question: presetQuestion ||
        {
          name: '',
          1: '',
          2: '',
          3: '',
          4: '',
          5: '',
          weight: '1'
        },
      errors: {},
      isCreating: !presetQuestion
    };
  }

  componentWillMount() {
    if (!this.props.assessment.subsections[this.props.match.params.subId]) {
      this.props.history.push('/assessments/create');
    }
  }

  validate = () => {
    const requiredFields = ['1', '2', '3', '4', '5', 'name'];
    let errors = {};

    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state.question[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    this.setState({errors: errors});
    return Object.keys(errors).length === 0;
  };

  onChange = event => {
    let target = event.target;
    this.setState(prevState => {
      prevState.question[target.name] = target.value;
      return prevState;
    });
  };

  onCancel = () => {
    this.props.history.push('/assessments/create');
  };

  onSubmit = event => {
    event.preventDefault();

    if (this.validate()) {
      if(this.state.isCreating) {
        this.props.saveQuestion(this.props.match.params.subId, this.state.question);
      } else {
        this.props.updateQuestion(this.props.match.params.subId, this.props.match.params.qId, this.state.question);
      }
      this.props.history.push('/assessments/create');
    }
  };

  render() {
    return (
      <div>
        <h2 className='ta-center'>{this.state.isCreating ? 'Add Question to' : 'Edit Question from'} { (this.props.assessment.subsections[this.props.match.params.subId] || {}).name || `Subsection ${+this.props.match.params.subId + 1}` }</h2>
        <br/>
        <Form horizontal onSubmit={this.onSubmit}>
          <FormGroup validationState={this.state.errors && this.state.errors.name ? 'error' : null } controlId="formHorizontalName">
            <Col xs={3} componentClass={ControlLabel}>
              Question Name
            </Col>
            <Col xs={6}>
              <FormControl data-cy="question-name" name="name" type="text" placeholder="Question Name" value={this.state.question.name} onChange={this.onChange}/>
              <FormControl.Feedback />
              { this.state.errors.name ? <HelpBlock>{this.state.errors.name}</HelpBlock> : '' }
            </Col>
          </FormGroup>

          { Object.keys(this.state.question).filter(x => !isNaN(+x)).map((key, i) => {

            return (
              <FormGroup key={i} validationState={this.state.errors && this.state.errors[key] ? 'error' : null } controlId={`formHorizontal${key}`}>
                <Col xs={3} componentClass={ControlLabel}>
                  Level {key} Text
                </Col>
                <Col xs={6}>
                  <FormControl data-cy={`question-text-${key}`} name={key} type="text" componentClass="textarea" value={this.state.question[key]} onChange={this.onChange}/>
                  <FormControl.Feedback />
                  { this.state.errors[key] ? <HelpBlock data-cy={'helpblock-' + key}>{this.state.errors[key]}</HelpBlock> : '' }
                </Col>
              </FormGroup>
            );
           })
          }
          <FormGroup>
            <Col xs={6}>
              <div className={'text-right'}>
                <Button data-cy="cancel-question" onClick={this.onCancel}>Cancel</Button>
                <Button
                  data-cy="save-question"
                  className='primary ml1'
                  type="submit"
                >
                  Save Question
                </Button>
              </div>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({ ...state.createAssessment });
const mapDispatchToProps = dispatch => ({
  saveQuestion: (subId, question) => dispatch(addQuestion({subId, question})),
  updateQuestion: (subId, qId, question) => dispatch(updateQuestion({subId, qId, question}))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAssessmentQuestion);



// WEBPACK FOOTER //
// ./src/components/assessments/assessment-form/EditAssessmentQuestion.js